import { useCallback, useEffect, useRef, useState } from 'react';
import { intervalToDuration } from 'date-fns';

const TIK = 1000;
const initTimer = 20000;

const zeroPad = (num?: number) => String(num).padStart(2, '0');

const timerFormater = (end = 0) => {
    const time = intervalToDuration({ start: 0, end });
    const minutes = time.minutes ?? 0;
    const seconds = time.seconds ?? 0;
    return `${zeroPad(minutes)}:${zeroPad(seconds)}`;
};

/**
 * Show duration in 00:00 format
 */

export const useTimerDuration = (ms = initTimer) => {
    const [timer, setTimer] = useState<number>(ms);
    const timerRef = useRef<string>(timerFormater(ms));
    const flagRef = useRef<boolean>(true);

    useEffect(() => {
        let t: NodeJS.Timer;
        if (flagRef.current) {
            t = setInterval(() => {
                setTimer((v) => {
                    if (v <= 0) {
                        flagRef.current = false;
                        timerRef.current = timerFormater(0);
                        return 0;
                    }
                    timerRef.current = timerFormater(v - TIK);
                    return v - TIK;
                });
            }, TIK);
        }

        return () => {
            clearInterval(t);
        };
    }, [timer]);

    const resetTimer = useCallback(
        (newMs?: number) => {
            setTimer(newMs || ms);
            timerRef.current = timerFormater(newMs || ms);
            flagRef.current = true;
        },
        [ms]
    );

    return { timer: timerRef.current, isTimerEnd: timer === 0, resetTimer };
};
